export default __webpack_public_path__ + "static/media/login-header.a51d3269.jpg";